import { DecimalPipe, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectImage, ProjectImageDateDisplay, ProjectMaterial } from 'src/app/objects/Project';
import { MatDialog } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ProjectMaterialAddComponent }from '../project-material-add/project-material-add.component'; 
import { ProjectImageUploadComponent } from '../project-image-upload/project-image-upload.component';
import { ProjectImageService } from 'src/app/Services/projectImages..service';
import { filter } from 'rxjs';
import { ProjectImagePopupComponent } from '../project-image-popup/project-image-popup.component';


@Component({
  selector: 'app-project-image',
  templateUrl: './project-image.component.html',
  styleUrls: ['./project-image.component.css']
})
export class ProjectImageComponent implements OnInit {

  constructor( private route: ActivatedRoute,
    private router: Router,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,
    private projectImageService: ProjectImageService,
    private dialog: MatDialog) {  
     }

     imageUrl: string = 'URL_TO_YOUR_IMAGE';
     isExpanded: boolean = false;
   
     ProjectId: number | any ;  project: Project |any;

     isLoadingResults: boolean | undefined; 
     showAvailbleMaterials: boolean | undefined; 
   
     dataSource!: MatTableDataSource<ProjectImage>;

     items: any[] = [];
     materials: Materials []=[];
     // ProjectMaterials: ProjectMaterial []=[];
     sortProperty: string = 'id';
     sortOrder = 1;
     sortListProperty: string = 'id';
     sortListOrder = 1;
     ProjectObject?: Project []=[];
     ProjectImageDateDisplay: ProjectImageDateDisplay []=[];



     ngOnInit(): void {
      this.route.paramMap.subscribe((params) => {
        this.ProjectId = parseInt(params.get('id') || '0', 10);
        if (this.ProjectId > 0) {
          this.loadProject(this.ProjectId);
        }
      }); 
     
    }
  
  
    openProjectImageDisplay(projectImage:ProjectImage): void {
      let dialogRef = this.dialog.open(ProjectImagePopupComponent, {
        height: '78%',
        width: '50%',
        data: { id : projectImage.id }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.loadProject(this.ProjectId);
      });
    }
  

  openImageUpload(): void {
    let dialogRef = this.dialog.open(ProjectImageUploadComponent, {
      
      data: { projectId: this.project.id }
    });

    dialogRef.afterClosed().subscribe(result => {
      //Load Project
   
      this.loadProject(this.ProjectId);
    });
  }
 loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project;
      this.loadDisplayImages();
        
    });
 
  }
  loadDisplayImages()
  { 
        this.filterDates(this.project.projectImage); 
  }

  filterDates(projectImage: ProjectImage[])
  { 
       for (var i = 0; i < projectImage.length; i++) {
      
        let data =  formatDate(projectImage[i].uploadDate, 'yyyy-MM-dd', 'en-US');
        let inArray = this.isStringInArray(data, this.ProjectImageDateDisplay);
        
        if (!inArray) { 
 
          let d: ProjectImageDateDisplay = {
            uploadDate: data,
            //projectImage: projectImage.filter(a=> a.uploadDate == projectImage[i].uploadDate)
            projectImage: projectImage.filter(a=> formatDate(a.uploadDate , 'yyyy-MM-dd', 'en-US') == data)
          }
          this.ProjectImageDateDisplay.push(d);
        }
      } 
  }

  toggleImage() {
    this.isExpanded = !this.isExpanded;
  }

   isStringInArray(needle:any, haystack:any) {
    for (var i = 0; i < haystack.length; i++) {
      if (needle === haystack[i].uploadDate) {
        return true;
      }
    }
    return false;
  }
  isDateInArray(needle:any, haystack:any) {
    for (var i = 0; i < haystack.length; i++) {
      if (needle.getTime() === haystack[i].getTime()) {
        return true;
      }
    }
    return false;
  }

  removeProjectImage(image:ProjectImage) 
  {
    
  
    this.projectImageService.deleteImage(image)
    .subscribe(res => {
       
        
        this.isLoadingResults = true; 
       
         
       this.loadProject(this.project?.id);
       
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });  
  }


}
